import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function ContextEngineeringPageHero() {
  return <section className="relative w-full pt-20 pb-32 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-520">
      {/* Background Image */}
      <div className="absolute top-0 right-0 pointer-events-none" style={{
      width: '100%',
      height: '800px'
    }} data-id="element-521">
        <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[12%] w-[100%] h-auto opacity-90" data-id="element-522" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-523">
        <div className="flex flex-col space-y-8" data-id="element-524">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 mt-20 w-fit" data-id="element-525">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-526">
              CONTEXT ENGINEERING
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-6xl font-['Syne']" data-id="element-527">
  AI runs on data.<br data-id="element-528" />
  Synthia adds{' '}
  <span className="bg-blue-600 text-white px-3" data-id="element-529">judgment.</span>
        </h1>

          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-530">
            Your institutional intelligence—compliance rules, quality standards,
            expert decision-making—doesn't fit in a prompt. Context engineering
            makes it machine-readable and enforces it structurally across every
            AI interaction.{' '}
            <strong className="text-black font-semibold" data-id="element-531">
              Build your context. Synthia activates it.
            </strong>
          </p>

          <div className="pt-4" data-id="element-532">
            <Link to="/how-it-works" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0066FF]" data-id="element-533">
              HOW IT WORKS
              <ArrowRight className="w-5 h-5" data-id="element-534" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}